<template>
   <div id="activity-vip" class="tac">
        <!-- <HeaderNav></HeaderNav> -->
        <div class="banner">
            <div class="content">
                <div class="countdown-box ofh">
                    <div class="inner df ai-c js-c">
                        <span class="txt">距今天活动结束：</span>
                        <span class="num">{{ this.countData.time }}</span>
                        <span class="txt">时</span>
                        <span class="num">{{ this.countData.minute }}</span>
                        <span class="txt">分</span>
                        <span class="num">{{ this.countData.second }}</span>
                        <span class="txt">秒</span>
                        <span class="num">{{ this.countData.millisecond }}</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="module-item vip-join">
            <div class="content">
                <div class="join-box">
                    <div class="item join-item"
                    v-for="(item, index) in joinData"
                    :key="index">
                        <p class="txt1">{{ item.txt1 }}</p>
                        <p class="txt2">{{ item.txt2 }}</p>
                    </div>
                </div>
                <a href="javascript:;" class="vip-btn"
                @click="showVip()">加入VIP，享更多权益</a>
            </div>
        </div>
        <div class="module-item vip-open">
            <div class="content">
                <img src="@/assets/images/activity/vip/01/title01.png" alt="" class="vip-title">
                <div class="open-box">
                    <template v-if="openData.length">
                        <div class="item open-item"
                        v-for="(item, index) in openData"
                        :key="index"
                        :class="`open-item0${index+1}`">
                            <div class="txt1">{{ item.vcc_name }}</div>
                            <div class="df ai-c js-c">
                                <div class="txt2 f1 tar" v-html="item.txt2"></div>
                                <div class="df">
                                    <div class="txt3">{{ Number(item.vcc_price) }}<span class="unit">元</span></div>
                                    <div class="txt4"><del>¥{{ Number(item.vcc_original_price) }}</del></div>
                                </div>
                            </div>
                            <a :href="item.link" target="_blank" class="link scale-btn" v-if="item.link_txt">{{ item.link_txt }}</a>
                        </div>
                    </template>
                </div>
                <a href="javascript:;" class="vip-btn"
                @click="showVip()">立即充值，开启学习</a>
            </div>
        </div>
        <div class="module-item vip-rights">
            <div class="content">
                <img src="@/assets/images/activity/vip/01/title02.png" alt="" class="vip-title">
                <div class="rights-box">
                    <div class="item rights-item df ai-c js-sb style1 first">
                        <div class="lt">开通礼包</div>
                        <div class="rt f1 df ai-c">
                            <div class="sub sub1 f1"
                            @click="showVip()">
                                <p class="txt1">通用券</p>
                                <p class="txt2">¥20</p>
                                <p class="txt3">无门槛</p>
                            </div>
                            <div class="sub sub2 f1"
                            @click="showVip()">
                                <p class="txt1">折扣券</p>
                                <p class="txt2">8折</p>
                                <p class="txt3 tove">（除特训营）</p>
                            </div>
                        </div>
                    </div>
                    <div class="item rights-item df ai-c js-sb style1 second"
                    :class="{'show-receive-btn': showReceiveBtn }">
                        <div class="lt">生日礼券</div>
                        <div class="rt f1 df ai-c">
                            <div class="sub sub1 f1">
                                <p class="txt1">通用券</p>
                                <p class="txt2">¥80</p>
                                <p class="txt3 tove">（满300-80）</p>
                            </div>
                            <div class="sub sub2 f1">
                                <p class="txt1">学习卡</p>
                                <p class="txt2">¥199</p>
                                <p class="txt3 tove">（免费观看时限30天）</p>
                            </div>
                            <div class="receive-btn df ai-c js-c scale-btn" v-if="showReceiveBtn"
                            @click="setData('showBirthdayPopup', true)">
                                <div class="inner">领取</div>
                            </div>
                        </div>
                    </div>
                    <div class="item rights-item df ai-c js-sb style2">
                        <div class="lt">VIP教程</div>
                        <div class="rt f1">
                            <p class="txt1"><span class="key">11537+课时任意学</span>，VIP专享免费看</p>
                            <a href="//m.yiihuu.com/vip/" target="_blank" class="btn">点击查看</a>
                        </div>
                    </div>
                    <div class="item rights-item df ai-c js-sb style2">
                        <div class="lt">工程文件</div>
                        <div class="rt f1">
                            <p class="txt1"><span class="key key2">限时免费下载</span></p>
                            <!-- <a href="//m.yiihuu.com/video/zuhe.php?id=144" target="_blank" class="btn">点击查看</a> -->
                            <p class="key-btn">请在电脑端登录点击查看</p>
                        </div>
                    </div>
                    <div class="item rights-item df ai-c js-sb style2">
                        <div class="lt">在线设计</div>
                        <div class="rt f1">
                            <p class="txt1"><span class="key">限时30W+</span>精品模板在线设计</p>
                            <p class="key-btn">请在电脑端登录点击查看</p>
                        </div>
                    </div>
                    <div class="item rights-item df ai-c js-sb style2">
                        <div class="lt">尊享课程</div>
                        <div class="rt f1">
                            <p class="txt1">指定付费课程，可每天免费观看<span class="key">2课时</span></p>
                            <a href="//m.yiihuu.com/zt_soft/22" target="_blank" class="btn">点击查看</a>
                        </div>
                    </div>
                </div>
                <a href="javascript:;" class="vip-btn"
                @click="showVip()">成为VIP，立即尊享</a>
            </div>
        </div>
        <div class="module-item vip-courses">
            <div class="content">
                <img src="@/assets/images/activity/vip/01/title03.png" alt="" class="vip-title">
                <div class="course-box">
                    <div class="inner">
                        <p class="course-tips">~我们会不定期更换，喜欢本期资产模型的童鞋不要错过哦~</p>
                        <div class="course-list tal" v-if="projectData.length">
                            <div class="item df fdc ofh"
                            v-for="(item, index) in projectData"
                            :key="index">
                                <div class="course-top">
                                    <img v-lazy="item.img" alt="" class="cover">
                                <!-- <img src="https://img12.yiihuu.com/upimg/album/2020/11/17/1-1605578439-197173.jpg" alt="" class="cover"> -->
                                </div>
                                <div class="course-mid f1">
                                    <div class="course-tit limite-line-2">
                                        {{ item.album_project_name }}
                                    </div>
                                </div>
                                <div class="course-bot df ai-c js-sb">
                                    <div class="txt">{{ $CommonFun.teachFun(item.down_count) }}人下载</div>
                                    <a href="javascript:;" class="download-btn df ai-c js-c"
                                    @click="showTips('充值超级VIP即可下载哦')" v-if="!isVip">立即下载</a>
                                    <template v-else>
                                        <!-- b端 -->
                                        <!-- <a href="item.album_project_src" class="download-btn df ai-c js-c" target="_blank" v-if="item.album_project_source==2">立即下载</a> -->
                                        <!-- 主站 -->
                                        <!-- <a :href="`https://vdown.yiihuu.com/project/${item.album_project_src}`" class="download-btn df ai-c js-c" target="_blank" v-else>立即下载</a> -->
                                        <a href="javascript:;" class="download-btn df ai-c js-c" @click="showCourseTootipsFn">立即下载</a>
                                    </template>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <p class="course-tips2">请在电脑端登录下载</p>
                <div class="course-tootips df ai-c js-c"
                :class="{ show: showCourseTootips }">
                    请在电脑端登录下载
                </div>
            </div>
        </div>
        <div class="module-item vip-sorts" v-if="albumData.length">
            <div class="content">
                <img src="@/assets/images/activity/vip/01/title04.png" alt="" class="vip-title">
                <div class="categary-box">
                    <ul class="cate-tabs df ai-c wsnw ofh">
                        <li
                        v-for="(item, index) in albumData"
                        :key="index"
                        :class="{ on: index == vipTabs.level1.index }"
                        @click="setVipTabsLevelIndex('level1', index, item.vic_id)"
                        >
                        <!-- {{ item.vic_id }} -->
                        {{ item.vc_name }}
                        </li>
                    </ul>
                    <!-- <ul class="sub-cate-tabs df fw" v-if="vipTabs.level1.index">
                        <li
                        class="tove"
                        v-for="(item, index) in initData.vip_boutique_data.vip_boutique_title.boutique_titles[vipTabs.level1.index]['childInd']"
                        :key="index"
                        :class="{ on: index == vipTabs.level2.index }"
                        @click="setVipTabsLevelIndex('level2', index, item.vpc_id)"
                        >
                        {{ item.vic_name }}
                        </li>
                    </ul> -->
                </div>
                <div class="course-list tal">
                    <a target="_blank" class="item df fdc"
                    v-for="(item, index) in vipTabsData"
                    :key="index"
                    :href="`${$commonVariable.yihu_href_url}/a_${item.album_id}.html`"
                    >
                        <div class="course-top">
                        <img v-lazy="item.album_picpath" alt="" class="cover">
                        </div>
                        <div class="course-mid f1">
                        <div class="course-tit limite-line-2">
                            {{ item.album_name }}
                        </div>
                        </div>
                        <div class="course-bot df js-sb">
                        <div class="df ai-c">
                            <span>{{ item.album_level_sort }}</span>
                            <span class="dot">·</span>
                            <span>{{ $CommonFun.teachFun(item.play_count) }}人在学</span>
                            <span class="dot">·</span>
                            <span class="times">{{ item.album_play_time }}</span>
                        </div>
                        </div>
                    </a>
                </div>
                <a target="_blank" class="tac view-more"
                :href="vipViewMoreLink"><span class="inner">点击查看更多</span></a>
                <a href="javascript:;" class="vip-btn"
                @click="showVip()">成为VIP，立即尊享</a>
            </div>
        </div>
        <div class="module-item vip-answer">
            <div class="content">
                <img src="@/assets/images/activity/vip/01/title05.png" alt="" class="vip-title">
                <div class="answer-box tal ofh">
                    <dl>
                        <template
                        v-for="(item, index) in answerData">
                            <dt>{{ item.q }}</dt>
                            <dd>{{ item.a }}</dd>
                        </template>
                    </dl>
                </div>
            </div>
        </div>
        <!-- <FooterNav></FooterNav>-->

        <!-- 生日礼券弹窗 -->
        <el-dialog
            :visible.sync="showBirthdayPopup"
            :show-close=false
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            width="776px"
            class="no-padding-dialog"
            custom-class="birthday-dialog">
            <div class="coupon-box">
                <i class="close"
                @click="setData('showBirthdayPopup',false)"></i>
                <a href="javascript:;" class="get-bag-btn"
                @click="getGiftBag()">点击立即领取</a>
            </div>
        </el-dialog>
   </div>
</template>
<script>
    import { mapGetters } from 'vuex'
    import { getToken } from '@/utils/auth'
    import { header as getHeader, user as getUser } from '@/api/common'
    import {getSvipList, getAlbumProjectList, getBirthdayGiftBag} from "@/api/activity/vip"
    let joinData=[
        { txt1:'开通礼包', txt2:'购课补贴福利' },
        { txt1:'尊享课程', txt2:'每天免费观看2课时' },
        { txt1:'专享特价', txt2:'单付费课享会员折扣' },
        { txt1:'生日礼券', txt2:'VIP专属生日惊喜' },
        { txt1:'VIP教程', txt2:'11537+课时任意学' },
        { txt1:'工程文件', txt2:'限时免费下载' },
        { txt1:'积分好礼', txt2:'VIP专属兑换商品' },
        { txt1:'在线设计', txt2:'30W+精品模版' },
    ]
    let openData=[
        // { txt1: '1年超级VIP', txt2: '立减70元',txt3:'128',txt4:'198'},
        // { txt1: '3年超级VIP', txt2: '充一享二',txt3:'298',txt4:'598', link: '//m.yiihuu.com/ex/71', link_txt:'领399元精品课'},
        // { txt1: '终身超级VIP', txt2: '充一赠六', txt3: '788', txt4: '1999',link:'//m.yiihuu.com/ex/97', link_txt: '赠¥2000课' },
    ]
    let projectInitData=[
        { img: 'https://img2.yiihuu.com/upimg/manage/2024/03/27/17115070621330.png' },
        { img: 'https://img2.yiihuu.com/upimg/manage/2024/03/27/17115070763017.png' },
        { img: 'https://img2.yiihuu.com/upimg/manage/2024/03/27/17115070914555.png' },
        { img: 'https://img2.yiihuu.com/upimg/manage/2024/03/27/1711507106891.png' },
        { img: 'https://img2.yiihuu.com/upimg/manage/2024/03/27/17115071313445.png' },
        { img: 'https://img2.yiihuu.com/upimg/manage/2024/03/27/17115071494942.png' },
        { img: 'https://img2.yiihuu.com/upimg/manage/2024/03/27/17115071826142.png' },
        { img: 'https://img2.yiihuu.com/upimg/manage/2024/03/27/17115071941130.png' },
    ]
    let answerData=[
        {q:'如何充值？',a:'翼狐网VIP目前支持支付宝、花呗、微信、京东支付等多种支付方式，具体请查看支付界面。'},
        { q: '开通会员后，会员权益何时生效？', a: '开通会员立即生效，续费会员有效期自动叠加，会员过期后续费不享受续费价格。' },
        {q:'VIP是否可以观看站内所有教程？',a:'不是，翼狐网教程有两种：VIP教程&单付费教程；VIP教程不能单独购买，需开通对应VIP才能观看学习；单付费教程需另外付费购买，可享受VIP优惠价。'},
        {q:'分类VIP和超级VIP有什么区别？',a:'【分类VIP】不同的分类VIP，可观看对应分类的VIP教程；【超级VIP】网站VIP专区所有VIP教程均可无限观看学习。'},
        {q:'可以提供软件和配套文件吗？',a:'由于版权原因，无法提供软件下载，开通VIP或购买教程后即可下载配套文件，边学边练。'},
        {q:'教程视频是否可以下载观看？',a:'电脑端暂时只能在线观看，下载【翼狐APP】可以离线缓存视频；温馨提示：APP缓存的视频只能在APP上观看。'},
        {q:'购买后支持退款吗？',a:'在VIP有效期内视频可以反复观看，由于VIP视频是虚拟物品，购买之后不支持退款，我们提供了部分免费试看视频，请试看之后慎重购买。'},
        {q:'充值VIP，但是无法观看视频？',a:'首先确认VIP充值类型是否有误，若VIP类型充值错误，当天可以联系客服更换，若出现其他错误，亦可联系客服（QQ：389559687）处理。'},
        {q:'开通礼包充值成功就送吗？',a:'是的，但享有该权益用户是1年超级VIP、3年超级VIP和终身超级VIP哦！'},
        {q:'生日礼包如何领取？',a:'在会员期内，VIP用户每年都可以领取，生日当天发放后7天有效（需提前设置生日日期），可在我的-个人中心处查看。'},
    ]

    let timer
    export default {
        name: "ActivityVip",
        components: {},
        data() {
            return {
                countData: {
                    time: 0,
                    minute: 0,
                    second: 0,
                    millisecond: 0,
                },
                joinData,
                openData,
                projectData:[],
                albumData:[],
                answerData,
                h5Data: {},
                initData:null,
                vipTabsData: [],//vip专区数据
                vipTabs: {//vip tab选中索引标识
                    "level1": {
                        index: 0,
                        first_vpc_id: 0,
                        vpc_inds_id: 0
                    },
                    "level2": {
                        index: 0,
                        second_vpc_id: 0,
                        vpc_inds_id: 0
                    }
                },
                member:null,//用户信息
                isVip:false,
                showBirthdayPopup: false,
                showCourseTootips:false
            };
        },
        created() {

        },
        mounted() {
            this.showTime()

            if (this.token) {
                this.getUser()
            }

            this.getHomeDataFn()
        },
        computed:{
            // ...mapGetters(['token']),
            token:function(){
                let token= getToken()
                return token
            },
            isTodayBirthday:function(){//是否今天生日
                let bol=false
                if(!this.token){ //未登录
                    return bol
                }

                let { member_birth }=this.member
                member_birth= member_birth.replaceAll('-','/')
                let birthday= new Date(member_birth)
                let today = new Date()
                if(birthday.getMonth()== today.getMonth()  && birthday.getDate() == today.getDate()){
                    bol=true
                }
                return bol
            },
            showReceiveBtn:function(){//是否显示生日领取按钮
                let bol=false
                 if(this.isVip && this.isTodayBirthday){//是vip && 今天生日
                    bol=true
                 }
                // bol = true
                return bol
            },
            vipViewMoreLink: function () {
                let index = this.vipTabs.level1.index

                let vpc_inds_id = this.vipTabs.level1['first_vpc_id']
                let link
                if (vpc_inds_id) {
                    link = `${this.$commonVariable.yihu_href_url}/list.php?s=3-0-0-0-${vpc_inds_id}-0-0-3-0/`
                } else {
                    link = `/vip/`
                }
                return link
            }
        },
        watch: {
            // "$store.getters.userinfo": {
            //     deep: true,
            //     handler(val) {
            //         if (this.token) {
            //             let {member}=val
            //             this.member = member
            //             this.isVip = this.member.is_vip
            //         }
            //     }
            // }
        },
        methods: {
            async getUser() {
                let res = await getUser()
                if (res.msg == "Success") {
                    let resData = res.data
                    this.member = resData.member
                    this.isVip = this.member.is_vip
                }
            },
            showTime(){
                let timerObj;
                let nowtime = new Date();
                let endtime = new Date(nowtime.getFullYear(), nowtime.getMonth(), nowtime.getDate(), 23, 59, 59, 999);
                let lefttime = parseInt((endtime.getTime() - nowtime.getTime()));
                let d = parseInt(lefttime / 1000 / (24 * 60 * 60));
                let h = parseInt(lefttime / 1000 / (60 * 60) % 24);
                let m = parseInt(lefttime / 1000 / 60 % 60);
                let s = parseInt(lefttime / 1000 % 60);
                let ms = parseInt(lefttime / 1000);
                if (lefttime > 0) {
                    d = parseInt(lefttime / 1000 / 60 / 60 / 24);
                    h = parseInt(lefttime / 1000 / 60 / 60 % 24);
                    m = parseInt(lefttime / 1000 / 60 % 60);
                    s = parseInt(lefttime / 1000 % 60);
                    ms = parseInt(lefttime % 1000);
                } else {
                    h = m = s = "00";
                    ms = '000';
                }
                d = this.PrefixInteger(d, 2);
                h = this.PrefixInteger(h, 2);
                m = this.PrefixInteger(m, 2);
                s = this.PrefixInteger(s, 2);
                ms = this.PrefixInteger(ms, 3);

                if (lefttime <= 0) {
                    timerObj && clearTimeout(timerObj);
                    window.location.reload(true);
                }
                this.countData = {
                    time: h,
                    minute: m,
                    second: s,
                    millisecond: ms,
                };
                timerObj = setTimeout(this.showTime, 40); 
            },
            PrefixInteger(num, length) {
                return (Array(length).join("0") + num).slice(-length);
            },
            //VIP弹窗
            showVip() {
                if (/isapp/i.test(this.uApp)) {//当前h5页面在APP内打开
                    this.h5Data = {
                        jumpData: {
                            jump_to_type: 2,
                            level: 2 //跳vip权益页
                        }
                    };
                    this.sendEventAction(this.h5Data);
                } else {
                    // alert('不是在app内打开')
                    // alert(navigator.userAgent)
                    location.href = this.$commonVariable.yihu_href_url + '/pay/wxpay1/buyvip_new.php?vip_type=45';// vip_type:设置默认的vip来源类型
                }
            },
            async getHomeDataFn() {
                this.getSvipListFn()
                this.getAlbumProjectListFn()
            },
            async getSvipListFn(){
                let res =await getSvipList()
                let {data}=res
                let newData =data.reverse()
                newData= newData.map((item,index)=>{
                    if(index==0){
                        item.txt2='<small>立减¥</small>70'
                    }else if(index==1){
                        item.txt2 = '充一享二'
                        item.link_txt='领399元精品课'
                        item.link='//m.yiihuu.com/ex/71'
                    }else if(index==2){
                        item.txt2 = '充一赠六'
                        item.link_txt = '赠¥2000课'
                        item.link = '//m.yiihuu.com/ex/97'
                    }
                })
                this.openData=data
            },
            async getAlbumProjectListFn() {
                let res = await getAlbumProjectList()
                let { project_data , album_data }=res.data
                this.projectData= project_data
                
                for (let i = 0; i < this.projectData.length; i++) {
                    const item = this.projectData[i];
                    item['img']= projectInitData[i]['img']
                    
                }

                this.albumData = album_data
                this.vipTabsData= this.albumData[0]['album_data'].slice(0,8)
                this.vipTabs.level1.first_vpc_id = this.albumData[0]['vic_id']
            },
            setVipTabsLevelIndex(level_, index_, vpcid_) {
                this.vipTabs[level_]['index'] = index_
                if (level_ == 'level1') {
                    this.vipTabs['level1']['first_vpc_id'] = vpcid_
                    this.vipTabs['level2']['index'] = 0
                    this.vipTabs['level2']['second_vpc_id'] = 0
                } else {
                    this.vipTabs['level2']['second_vpc_id'] = vpcid_
                }

                this.vipTabsData= this.albumData[index_]['album_data'].slice(0, 8)
            },
            showTips(msg_){
                if(!this.token){
                    this.$login.show()
                    return
                }
                this.$layer.msg(msg_)

                this.showVip()
            },
            async getGiftBag(){
                let params={
                    coupon_id:27585,
                    card_id:32
                }
                if(process.env.NODE_ENV=='production'){
                    params = {
                        coupon_id: 56667,
                        card_id: 110
                    }
                }
                let res = await getBirthdayGiftBag(params)

                this.setData('showBirthdayPopup', false)
                this.$layer.msg('领取成功')
            },
            setData(name_,boolean_){
                this[name_]= boolean_
            },
            showCourseTootipsFn(){
                this.showCourseTootips=true
                timer && clearTimeout(timer)
                timer=setTimeout(() => {
                    this.showCourseTootips = false
                }, 4000);
            },
            //h5页面通知APP，回传数据给APP
            sendEventAction(h5Data) {
                // console.log(`h5Data:${JSON.stringify(h5Data)}`)
                // console.log(`extraData:${JSON.stringify(extraData)}`)

                // 跟app交互主要方法
                // h5CallbackData、extraData 空值传{}
                // 跳转能力调用app内首页openEntrance方法
                api.sendEvent({
                    name: 'h5CallbackEvent',
                    extra: {
                        h5CallbackData: h5Data,
                        extraData: this.extraData
                    }
                });
            },
        },
    }
</script>

<style lang="scss" scoped src="@/assets/css/activity/vip/index.scss"></style>
